import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import Swal from 'sweetalert2';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { logout } from '../../services/auth';
import ReactSelect from "react-select"
import { useDispatch } from "react-redux";
import { setLoading } from '../../redux/formDataSlice';
import useUser from '../../hooks/useUser';

const emptyOption = { value: "", label: "Seleccionar" };
const weekOrder = {
  lunes: 1,
  martes: 2,
  miércoles: 3,
  jueves: 4,
  viernes: 5,
  sabado: 6,
  domingo: 7,
}

const EditTurnDate = ({ show, handleClose, data, date, getData }) => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useUser();

  const [dates, setDates] = useState([]);
  const [nextTurn, setNextTurn] = useState("");

  useEffect(() => {
    return () => {
      setNextTurn("")
    }
  }, []);

  useEffect(() => {
    if (data?.length) {
      let sortData = data.sort((a, b) => {

        if (+weekOrder[a.dia] > +weekOrder[b.dia]) {
          return 1;
        }
        if (+weekOrder[a.dia] < +weekOrder[b.dia]) {
          return -1;
        }
        return 0;
      });

      let result = sortData.map(e => {
        return {
          ...e,
          label: `${e.dia ? e.dia[0].toUpperCase() + e.dia.substring(1) : ""} - ${e.horario ? e.horario + " hs - " : ""} ${e.actividad ? e.actividad : ""}`,
          value: e.ids
        }
      })
      setDates(result);
    } else {
      setDates([]);
    }
  }, [data]);


  const handleSubmit = (e) => {
    e.preventDefault();
    if ((!date || !nextTurn || !nextTurn.value)) return Swal.fire("Incompleto", "Debe elegir un dia", "warning");

    return Swal.fire({
      title: `<h3 style="color:#0d6efd;">Modificar turnos</h3>`,
      html: `<div>
        <p>¿Esta seguro de estos cambios?</p>
      </div>`,
      icon: `warning`,
      showConfirmButton: true,
      showDenyButton: true,
      confirmButtonText: "Si",
      denyButtonText: "No",
      confirmButtonColor: "green",
    })
      .then(async (response) => {
        if (response.isConfirmed) {

          dispatch(setLoading(true));
          let response = await axiosPrivate.patch("/reserves/changeDateActivity", {
            id_usuario: user.id,
            prevTurn: {
              ...date,
              dates: `${date.dia ? date.dia[0].toUpperCase() + date.dia.substring(1) : ""} - ${date.horario ? date.horario + " hs" : ""}`
            },
            nextTurn: {
              ...nextTurn,
              dates: `${nextTurn.dia ? nextTurn.dia[0].toUpperCase() + nextTurn.dia.substring(1) : ""} - ${nextTurn.horario ? nextTurn.horario + " hs" : ""}`
            }
          });

          if (response.status === 200) {
            getData();
            dispatch(setLoading(false));

            return Swal.fire({
              title: "¡Éxito!",
              text: "El turno fue modificado exitosamente.",
              icon: "success",
              willClose: () => handleClose(),
            })
          } else {
            dispatch(setLoading(false));
            return Swal.fire({
              title: "¡Error!",
              text: "Ocurrio un error durante el proceso, intentelo nuevamente.",
              icon: "error",
            });
          }
        }
      })
      .catch(err => {
        console.log(err);
        if (err.response?.status === 403 || err.response?.status === 401) {
          dispatch(setLoading(false));
          return Swal.fire({
            title: "¡Error!",
            text: "Su sesión expiro, vuelva a iniciar sesión.",
            icon: "warning",
            willClose: () => {
              logout();
              return navigate("/");
            },
          });
        }
        dispatch(setLoading(false));

        return Swal.fire({
          title: "Error!",
          text: "Ocurrio un error durante el proceso, intentelo nuevamente",
          icon: "error",
        });
      });
  };

  const handleChange = (e) => {
    setNextTurn(e)
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
    >
      <Modal.Body className='p-5'>
        <h4 className='text-center'>Cambiar dia de la actividad</h4>
        <div className='mt-4' style={{ fontSize: 16 }}>
          <div>
            <span style={{ fontWeight: 600, marginTop: 10 }} >Actividad:</span> {date.actividad ? date.actividad : ""}
          </div>
          <div>
            <span style={{ fontWeight: 600, marginTop: 10 }} >Dia actual:</span> {date.dia ? date.dia[0].toUpperCase() + date.dia.substring(1) + " - " : ""}{date.horario ? date.horario + " hs" : ""}
          </div>
        </div>
        <Row>
          <Col className='mt-3'>
            <Form.Label className="label">Fecha <span className='text-red'>*</span></Form.Label>
            <ReactSelect
              options={dates?.length ? [emptyOption, ...dates] : [emptyOption]}
              onChange={handleChange}
            />
          </Col>
        </Row>
        <div className='mt-4'>
          <span className='text-danger'>* Las actividades intercambiarán los días seleccionados</span>
        </div>

        <div className="d-flex justify-content-center mt-5">
          <Button onClick={handleSubmit} className='me-3'>Cambiar</Button>
          <Button variant='danger' onClick={handleClose}>Cancelar</Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default EditTurnDate;